import { merge, fromEvent } from 'rxjs';
import { map, switchMap, takeUntil, scan, takeLast, filter } from 'rxjs/operators';

class SwipeDetect {
    constructor(document, targetElement, sensitivity = 100) {
        this.document = document;
        this.targetElement = targetElement;
        this.sensitivity = sensitivity;
        let nativeElement = this.document;
        if (targetElement !== null && targetElement !== undefined) {
            nativeElement = targetElement.nativeElement;
        }
        this.mouseDown = merge(fromEvent(nativeElement, 'mousedown', { passive: true }), fromEvent(nativeElement, 'touchstart', { passive: true }));
        this.mouseUp = merge(fromEvent(nativeElement, 'mouseup', { passive: true }), fromEvent(nativeElement, 'touchend', { passive: true }));
        this.mouseMove = merge(fromEvent(nativeElement, 'mousemove', { passive: true }), fromEvent(nativeElement, 'touchmove', { passive: true }));
    }
    direction() {
        return this.amount().pipe(map((amount) => (amount > 0 ? 'LEFT' : 'RIGHT')));
    }
    amount() {
        // UIEvent.layerX is used instead of offsetX, in case if offsetX returns 0 (Firefox)
        return this.mouseDown.pipe(switchMap((startEvent) => this.mouseMove.pipe(takeUntil(this.mouseUp), map((event) => 'touches' in event
            ? event.touches[0]?.pageX
            : event.offsetX || event.layerX), scan((_acc, pageX) => Math.round(('touches' in startEvent
            ? startEvent?.touches[0]?.pageX
            : startEvent?.offsetX || startEvent?.layerX) - pageX), 0), takeLast(1), filter((difference) => difference >= this.sensitivity || -difference >= this.sensitivity))));
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { SwipeDetect };
